import { Flex, Button } from "antd";
import { FilterFactory } from "./FilterFactory";

/**
 * ReportFilters — панель фильтров для отчёта.
 * Отрисовывает контролы в зависимости от типа фильтра и
 * прокидывает изменения наружу.
 *
 * props:
 *  - filters: массив конфигураций фильтров [{ name, title, type, isRequired, object_uuid? }]
 *  - filterValues: текущие значения фильтров по имени { [name]: value }
 *  - onFilterChange(name, value): колбэк при изменении значения фильтра
 *  - onGenerate(): колбэк запуска генерации отчёта
 *  - pending: признак загрузки/генерации для кнопки
 *  - statusOptions, employeesOptions, unitsOptions: справочники для соответствующих типов
 *  - objectsOptions: объект справочников объектов по ключу definition_uuid
 */
const ReportFilters = ({
  filters,
  filterValues,
  onFilterChange,
  onGenerate,
  pending,
  statusOptions,
  employeesOptions,
  unitsOptions,
  objectsOptions,
}) => {
  return (
    <Flex vertical gap={10} align="flex-start">
      {/* Сетка контролов фильтров (скрыта при печати) */}
      <Flex gap={8} align="flex-end" wrap className="not-print">
        {filters.map((filter) => (
          <Flex vertical key={filter.name} gap={5}>
            <div className={`label ${filter.isRequired && "required"}`}>
              {filter.title}
            </div>
            <FilterFactory
              filter={filter}
              value={filterValues[filter.name]}
              onChange={(val) => onFilterChange(filter.name, val)}
              statusOptions={statusOptions}
              employeesOptions={employeesOptions}
              unitsOptions={unitsOptions}
              objectsOptions={objectsOptions[filter.object_uuid]}
            />
          </Flex>
        ))}
      </Flex>
      {/* Кнопка запуска генерации отчёта */}
      <Button type="primary" loading={pending} onClick={onGenerate}>
        Сформировать
      </Button>
    </Flex>
  );
};

export default ReportFilters;
